<template lang="pug">
  div.faq_content(v-if='loadingInfo === "loadedInfo"')
    p.title {{content.title}}
    p.content(v-html="content.content")
    div.corner(v-if="showCorner==='true'", @click="toSubmitPage")
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Faq',
  data(){
    return {
        content: '',
        id: '',
        showPicker: false,
        langid: 0,
        showCorner: 'false'
    }
  },
  created(){
    this.id = this.$route.query.id
    this.getFAQContentInfo(Qs.stringify({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      id: this.id,
      appId: this.appid,
      channelId: this.channelId,
      phoneModel: this.phoneModel,
      languageCode: this.lang
    }))
    // this.getSwitchInfo({
    //   uid: this.uid,
    //   deviceId: this.deviceId,
    //   accessToken: this.token,
    //   appId: this.appid,
    //   channelId: this.channelId,
    //   phoneModel: this.phoneModel,
    //   switchId: 13
    // })
  },
  methods:{
    ...mapActions(['getSwitchInfo']),
    ...mapActions('faq', ['getFAQContentInfo']),
    toSubmitPage(){
      if(this.$route.query.type === '1'){
        this.$router.push({
          path: '/faq/report',
          query: this.content
        })
      } else {
        this.$router.push({
          path: '/faq/submit',
          query: this.content
        })
      }
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'appid', 'channelId', 'switchInfo', 'switching', 'lang', 'phoneModel']),
    ...mapGetters('faq', ['errmsg', 'faqContentInfo', 'loadingInfo'])
  },
  mounted(){
    if(this.switchInfo.switchInfoList && this.switchInfo.switchInfoList[13]){
      this.showCorner = this.switchInfo.switchInfoList[13]
    }
    this.$watch('loadingInfo', val => {
      if(val === 'loadedInfo'){
        this.content = this.faqContentInfo.faqContentInfo
      }
    })
    this.$watch('switchInfo', val => {
      if(this.switchInfo.switchInfoList && this.switchInfo.switchInfoList[13]){
        this.showCorner = this.switchInfo.switchInfoList[13]
      }
    })
  }
}
</script>
<style lang="scss">
.faq_content{
  margin: 20px;
  .lang_select{
    width: 30%;
    position: relative;
    left: 70%;
    padding: 5px 10px;
    .van-field__body{
      &::after {
        position: absolute;
        top: 50%;
        right: -4px;
        margin-top: -5px;
        border: 3px solid;
        border-color: transparent transparent #dcdee0 #dcdee0;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        opacity: 0.8;
        content: '';
      }
    }
  }
  p{
    margin: 0;
    &.title{
      text-align: center;
      font-size: 24px;
      font-weight: bolder;
    }
    &.content{
      text-indent: 14px;
      font-size: 14px;
      img{
        width: 100%;
        height: auto;
        margin-left: -14px;
      }
    }
  }
  .corner{
    background: url(../../assets/faq_corner.png) 0 0 no-repeat;
    width: 30px;
    height: 30px;
    background-size: 100% auto !important;
    position: fixed;
    right: 20px;
    bottom: 100px;
  }
}
</style>